module.exports = __webpack_public_path__ + "static/media/M9.9be1a3e9.jpeg";